import {
  FETCH_BOOKMARKS_START,
  FETCH_BOOKMARKS_SUCCESS,
  FETCH_BOOKMARKS_FAILURE,
  FETCH_BOOKMARKS_PHOTO_START,
  FETCH_BOOKMARKS_PHOTO_SUCCESS,
  FETCH_BOOKMARKS_PHOTO_FAILURE,
  FETCH_BOOKMARKS_VIDEO_START,
  FETCH_BOOKMARKS_VIDEO_SUCCESS,
  FETCH_BOOKMARKS_VIDEO_FAILURE,
  SAVE_BOOKMARK_START,
  SAVE_BOOKMARK_SUCCESS,
  SAVE_BOOKMARK_FAILURE,
  DELETE_BOOKMARK_START,
  DELETE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK_FAILURE,
  UPDATE_BOOKMARK_POST_LIKES,
  SET_BOOKMARK_POST,
  SUBSCRIBE_TO_PLAN_SUCCESS,
} from "../actions/ActionConstant";
import { updatePostLike } from "../../components/helper/Utils";
import {
  replaceUpdatePost,
  modifyPostOnSubscribedToPerformer,
} from '../../components/helper/Utils'

const initialState = {
  bookmark: {
    data: {
      posts: [],
    },
    loading: true,
    error: false,
    inputData: {},
    skip: 0,
    page: 1,
    length: 0,
    hasNext: true,
  },
  bookmarkPhoto: {
    data: {
      posts: [],
    },
    loading: true,
    error: false,
    inputData: {},
    skip: 0,
    page: 1,
    length: 0,
    hasNext: true,
  },
  bookmarkVideo: {
    data: {
      posts: [],
    },
    loading: true,
    error: false,
    inputData: {},
    skip: 0,
    page: 1,
    length: 0,
    hasNext: true,
  },
  saveBookmark: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  deleteBookmark: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
};

const BookmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOKMARKS_START:
      const bookmarks = state.bookmark.data.posts || []
      return {
        ...state,
        bookmark: {
          inputData: action.data,
          data: {
            posts: [...bookmarks],
          },
          loading: true,
          error: false,
          skip: state.bookmark.skip,
          page: state.bookmark.page,
          length: state.bookmark.length,
        },
      };
    case FETCH_BOOKMARKS_SUCCESS:
      return {
        ...state,
        bookmark: {
          data: {
            posts:
              action.data.current_page === 1
                ? action.data.data || []
                : [...(state.bookmark.data.posts || []), ...(action.data.data || [])],
          },
          loading: false,
          error: false,
          inputData: {},
          skip: (action.data.data || []).length + state.bookmark.skip,
          page: action.data.current_page,
          length: (action.data.data || []).length,
          hasNext: action.data.next_page_url === null ? false : true,
        },
      };
    case FETCH_BOOKMARKS_FAILURE:
      return {
        ...state,
        bookmark: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          skip: state.bookmark.skip,
          length: state.bookmark.length,
        },
      };

    case FETCH_BOOKMARKS_PHOTO_START:
      return {
        ...state,
        bookmarkPhoto: {
          inputData: action.data,
          data: {
            posts: [...state.bookmarkPhoto.data.posts],
          },
          loading: true,
          error: false,
          skip: state.bookmarkPhoto.skip,
          page: state.bookmark.page,
          length: state.bookmarkPhoto.length,
        },
      };
    case FETCH_BOOKMARKS_PHOTO_SUCCESS:
      return {
        ...state,
        bookmarkPhoto: {
          data: {
            posts: [
              ...(state.bookmarkPhoto.data.posts || []),
              ...(action.data.data || [])
            ],
          },
          loading: false,
          error: false,
          inputData: {},
          skip: (action.data.data || []).length + state.bookmarkPhoto.skip,
          page: action.data.current_page,
          length: (action.data.data || []).length,
          hasNext: action.data.next_page_url === null? false : true
        },
      };
    case FETCH_BOOKMARKS_PHOTO_FAILURE:
      return {
        ...state,
        bookmarkPhoto: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          skip: state.bookmarkPhoto.skip,
          length: state.bookmarkPhoto.length,
        },
      };

    case FETCH_BOOKMARKS_VIDEO_START:
      return {
        ...state,
        bookmarkVideo: {
          inputData: action.data,
          data: {
            posts: [...state.bookmarkVideo.data.posts],
          },
          loading: true,
          error: false,
          skip: state.bookmarkVideo.skip,
          page: state.bookmarkVideo.page,
          length: state.bookmarkVideo.length,
        },
      };
    case FETCH_BOOKMARKS_VIDEO_SUCCESS:
      return {
        ...state,
        bookmarkVideo: {
          data: {
            posts: [
              ...(state.bookmarkVideo.data.posts || []),
              ...(action.data.data || [])
            ],
          },
          loading: false,
          error: false,
          inputData: {},
          skip: (action.data.data || []).length + state.bookmarkVideo.skip,
          page: action.data.current_page,
          length: (action.data.data || []).length,
          hasNext: action.data.next_page_url === null? false : true
        },
      };
    case FETCH_BOOKMARKS_VIDEO_FAILURE:
      return {
        ...state,
        bookmarkVideo: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          skip: state.bookmarkVideo.skip,
          length: state.bookmarkVideo.length,
        },
      };
    case SAVE_BOOKMARK_START:
      return {
        ...state,
        saveBookmark: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case SAVE_BOOKMARK_SUCCESS:
      return {
        ...state,
        saveBookmark: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
        bookmark: {
          ...state.bookmark,
          data: {
            posts: action.data.isRemoved
              ? state.bookmark.data.posts.filter((entry) => entry.post_id !== action.data.post_id)
              : state.bookmark.data.posts,
          },
        },
        bookmarkPhoto: {
          ...state.bookmarkPhoto,
          data: {
            posts: action.data.isRemoved
              ? state.bookmarkPhoto.data.posts.filter(
                  (entry) => entry.post_id !== action.data.post_id,
                )
              : state.bookmarkPhoto.data.posts,
          },
        },
        bookmarkVideo: {
          ...state.bookmarkVideo,
          data: {
            posts: action.data.isRemoved
              ? state.bookmarkVideo.data.posts.filter(
                  (entry) => entry.post_id !== action.data.post_id,
                )
              : state.bookmarkVideo.data.posts,
          },
        },
      };
    case SAVE_BOOKMARK_FAILURE:
      return {
        ...state,
        saveBookmark: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case DELETE_BOOKMARK_START:
      return {
        ...state,
        deleteBookmark: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading...",
          buttonDisable: true,
        },
      };
    case DELETE_BOOKMARK_SUCCESS:
      return {
        ...state,
        deleteBookmark: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case DELETE_BOOKMARK_FAILURE:
      return {
        ...state,
        deleteBookmark: {
          data: {},
          loading: false,
          error: action.data,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case SET_BOOKMARK_POST:
      return {
        ...state,
        bookmark: {
          ...state.bookmark,
          data: {
            posts: replaceUpdatePost(
              state.bookmark.data?.posts || [],
              action.data.post
            ),
          },
        },
        bookmarkPhoto: {
          ...state.bookmarkPhoto,
          data: {
            posts: replaceUpdatePost(
              state.bookmarkPhoto.data?.posts || [],
              action.data.post
            ),
          },
        },
        bookmarkVideo: {
          ...state.bookmarkVideo,
          data: {
            posts: replaceUpdatePost(
              state.bookmarkVideo.data?.posts || [],
              action.data.post
            ),
          },
        },
      };
    case SUBSCRIBE_TO_PLAN_SUCCESS:
      return {
        ...state,
        bookmark: {
          ...state.bookmark,
          data: {
            posts: modifyPostOnSubscribedToPerformer(
              state.bookmark.data?.posts || [],
              action.data
            ),
          },
        },
        bookmarkPhoto: {
          ...state.bookmarkPhoto,
          data: {
            posts: modifyPostOnSubscribedToPerformer(
              state.bookmarkPhoto.data?.posts || [],
              action.data
            ),
          },
        },
        bookmarkVideo: {
          ...state.bookmarkVideo,
          data: {
            posts: modifyPostOnSubscribedToPerformer(
              state.bookmarkVideo.data?.posts || [],
              action.data
            ),
          },
        },
      };

    case UPDATE_BOOKMARK_POST_LIKES:
      return {
        ...state,
        bookmark: {
          ...state.bookmark,
          data: {
            ...state.bookmark.data,
            posts: updatePostLike(state.bookmark.data.posts, action.data),
          },
        },
        bookmarkPhoto: {
          ...state.bookmarkPhoto,
          data: {
            ...state.bookmarkPhoto.data,
            posts: updatePostLike(state.bookmarkPhoto.data.posts, action.data),
          },
        },
        bookmarkVideo: {
          ...state.bookmarkVideo,
          data: {
            ...state.bookmarkVideo.data,
            posts: updatePostLike(state.bookmarkVideo.data.posts, action.data),
          },
        },
      };

    default:
      return state;
  }
};

export default BookmarkReducer;
